import React, { useState, useEffect } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import Button from 'react-bootstrap/Button';
import { useFilterContext } from '../../TauriGlobalContext/TauriGlobalContext';
import TauriExportDialog from '../../TauriExportDialog/TauriExportDialog';
import setting from '../../../config.json';
import './TauriFilter.css';

const TauriFilter = () => {
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonthIndex = currentDate.getMonth();
    const numberOfYears = 1;
    const [showExport, setShowExport] = useState(false)
    // const [refreshTrigger, setRefreshTrigger] = useState(null);

    const years = [];
    for (let i = currentYear - numberOfYears; i <= currentYear; i++) {
        years.push(i);
    }

    const initialFromMonth = localStorage.getItem('FromMonth') ? parseInt(localStorage.getItem('FromMonth')) : currentMonthIndex + 1;
    const initialFromYear = localStorage.getItem('FromYear') ? parseInt(localStorage.getItem('FromYear')) : currentYear;
    const initialToMonth = localStorage.getItem('ToMonth') ? parseInt(localStorage.getItem('ToMonth')) : currentMonthIndex + 1;
    const initialToYear = localStorage.getItem('ToYear') ? parseInt(localStorage.getItem('ToYear')) : currentYear;
    const getUserData = localStorage.getItem('UserData');
    const decodedUserData = JSON.parse(atob(getUserData));

    const getPermission = localStorage.getItem('permission');
    const decodedPermission = JSON.parse(atob(getPermission));

    const { updateFilterValue } = useFilterContext();

    const ACCESS_TYPE_MAP = {
        agent: { type: "agent", value: 1 },
        district: { type: "district", value: 2 },
        distributor: { type: "distributor", value: 3 },
        regions: { type: "region", value: 4 },
        executive: { type: "executive", value: 5 }
    };

    const accessLevels = [
        { level: 2, codeKey: 'DistrictManagerCode' },
        { level: 1, codeKey: 'AgentCode' },
        { level: 4, codeKey: 'RegionCode' },
        { level: 3, codeKey: 'DistributorCode' },
        { level: 5, codeKey: 'National' },
    ];

    let accessDetails = [];
    let configTypeCode = [];
    let codeName = '';

    const userAccessLevel = decodedPermission?.DataScope?.Access || -1;
    const accessLevelDetail = accessLevels.find(item => item.level === userAccessLevel);

    if (accessLevelDetail) {
        accessDetails = decodedUserData?.CodeList || [];

        configTypeCode = setting.ConfigTypeCode?.split(',') || [];
        codeName = accessLevelDetail.codeKey;
    }

    let emp = decodedPermission?.DataScope?.AccessRange?.split(',') || [];
    const concatenatedList = emp.flatMap(accessItem =>
        (decodedUserData?.CodeList || []).map(code => `${accessItem}|${code}`)
    );

    const initialCode = accessDetails.length > 0 ? accessDetails[0].trim() : '';
    const initialConfigTypeCode = configTypeCode.length > 0 ? configTypeCode[0].trim() : '';

    const [selectedFromMonth, setSelectedFromMonth] = useState(initialFromMonth);
    const [selectedFromYear, setSelectedFromYear] = useState(initialFromYear);
    const [selectedToMonth, setSelectedToMonth] = useState(initialToMonth);
    const [selectedToYear, setSelectedToYear] = useState(initialToYear);
    const [selectedCode, setSelectedCode] = useState(initialCode);
    const [selectedConfigTypeCode, setSelectedConfigTypeCode] = useState(initialConfigTypeCode);

    const handleFromMonthChange = (index) => {
        const selectedMonth = index + 1;
        setSelectedFromMonth(selectedMonth);
        localStorage.setItem('FromMonth', selectedMonth);
        updateFilterValue({
            FromMonth: selectedMonth.toString(),
            FromYear: selectedFromYear.toString(),
            ToMonth: selectedToMonth.toString(),
            ToYear: selectedToYear.toString(),
            [codeName]: selectedCode === 'ALL' ?
                (decodedPermission?.DataScope?.Access === ACCESS_TYPE_MAP.agent.value ? concatenatedList.toString() : decodedUserData?.CodeList.toString()) :
                (decodedPermission?.DataScope?.Access === ACCESS_TYPE_MAP.agent.value ? decodedPermission?.DataScope?.AccessRange + '|' + selectedCode.toString() : selectedCode.toString()),
            ConfigTypeCode: selectedConfigTypeCode.toString()
        });
    };

    const handleFromYearChange = (year) => {
        setSelectedFromYear(year);
        localStorage.setItem('FromYear', year);
        updateFilterValue({
            FromMonth: selectedFromMonth.toString(),
            FromYear: year.toString(),
            ToMonth: selectedToMonth.toString(),
            ToYear: selectedToYear.toString(),
            [codeName]: selectedCode === 'ALL' ?
                (decodedPermission?.DataScope?.Access === ACCESS_TYPE_MAP.agent.value ? concatenatedList.toString() : decodedUserData?.CodeList.toString()) :
                (decodedPermission?.DataScope?.Access === ACCESS_TYPE_MAP.agent.value ? decodedPermission?.DataScope?.AccessRange + '|' + selectedCode.toString() : selectedCode.toString()),
            ConfigTypeCode: selectedConfigTypeCode.toString()
        });
    };

    const handleToMonthChange = (index) => {
        const selectedMonth = index + 1;
        setSelectedToMonth(selectedMonth);
        localStorage.setItem('ToMonth', selectedMonth);
        updateFilterValue({
            FromMonth: selectedFromMonth.toString(),
            FromYear: selectedFromYear.toString(),
            ToMonth: selectedMonth.toString(),
            ToYear: selectedToYear.toString(),
            [codeName]: selectedCode === 'ALL' ?
                (decodedPermission?.DataScope?.Access === ACCESS_TYPE_MAP.agent.value ? concatenatedList.toString() : decodedUserData?.CodeList.toString()) :
                (decodedPermission?.DataScope?.Access === ACCESS_TYPE_MAP.agent.value ? decodedPermission?.DataScope?.AccessRange + '|' + selectedCode.toString() : selectedCode.toString()),
            ConfigTypeCode: selectedConfigTypeCode.toString()
        });
    };

    const handleToYearChange = (year) => {
        setSelectedToYear(year);
        localStorage.setItem('ToYear', year);
        updateFilterValue({
            FromMonth: selectedFromMonth.toString(),
            FromYear: selectedFromYear.toString(),
            ToMonth: selectedToMonth.toString(),
            ToYear: year.toString(),
            [codeName]: selectedCode === 'ALL' ?
                (decodedPermission?.DataScope?.Access === ACCESS_TYPE_MAP.agent.value ? concatenatedList.toString() : decodedUserData?.CodeList.toString()) :
                (decodedPermission?.DataScope?.Access === ACCESS_TYPE_MAP.agent.value ? decodedPermission?.DataScope?.AccessRange + '|' + selectedCode.toString() : selectedCode.toString()),
            ConfigTypeCode: selectedConfigTypeCode.toString()
        });
    };

    const handleCodeChange = (code) => {
        const newCode = code === 'ALL' ? 'ALL' : code.toString();
        setSelectedCode(newCode);
        updateFilterValue({
            FromMonth: selectedFromMonth.toString(),
            FromYear: selectedFromYear.toString(),
            ToMonth: selectedToMonth.toString(),
            ToYear: selectedToYear.toString(),
            [codeName]: newCode === 'ALL' ?
                (decodedPermission?.DataScope?.Access === ACCESS_TYPE_MAP.agent.value ? concatenatedList.toString() : decodedUserData?.CodeList.toString()) :
                (decodedPermission?.DataScope?.Access === ACCESS_TYPE_MAP.agent.value ? decodedPermission?.DataScope?.AccessRange + '|' + newCode.toString() : newCode.toString()),
            ConfigTypeCode: selectedConfigTypeCode.toString()
        });
    };

    const handleConfigTypeCodeChange = (configtype) => {
        setSelectedConfigTypeCode(configtype);
        localStorage.setItem('ConfigTypeCode', selectedConfigTypeCode);
        updateFilterValue({
            FromMonth: selectedFromMonth.toString(),
            FromYear: selectedFromYear.toString(),
            ToMonth: selectedToMonth.toString(),
            ToYear: selectedToYear.toString(),
            [codeName]: selectedCode === 'ALL' ?
                (decodedPermission?.DataScope?.Access === ACCESS_TYPE_MAP.agent.value ? concatenatedList.toString() : decodedUserData?.CodeList.toString()) :
                (decodedPermission?.DataScope?.Access === ACCESS_TYPE_MAP.agent.value ? decodedPermission?.DataScope?.AccessRange + '|' + selectedCode.toString() : selectedCode.toString()),
            ConfigTypeCode: configtype.toString()
        });
    };

    useEffect(() => {
        localStorage.setItem('FromMonth', selectedFromMonth);
        localStorage.setItem('FromYear', selectedFromYear);
        localStorage.setItem('ToMonth', selectedToMonth);
        localStorage.setItem('ToYear', selectedToYear);
        localStorage.setItem('ConfigTypeCode', selectedConfigTypeCode);
        updateFilterValue({
            FromMonth: selectedFromMonth.toString(),
            FromYear: selectedFromYear.toString(),
            ToMonth: selectedToMonth.toString(),
            ToYear: selectedToYear.toString(),
            [codeName]: selectedCode === 'ALL' ?
                (decodedPermission?.DataScope?.Access === ACCESS_TYPE_MAP.agent.value ? concatenatedList.toString() : decodedUserData?.CodeList.toString()) :
                (decodedPermission?.DataScope?.Access === ACCESS_TYPE_MAP.agent.value ? decodedPermission?.DataScope?.AccessRange + '|' + selectedCode.toString() : selectedCode.toString()),
            ConfigTypeCode: selectedConfigTypeCode.toString()
        });
    }, [initialFromMonth, initialFromYear, initialToMonth, initialToYear]);

    const handleExportClick = () => {
        setShowExport(true);
    };

    const handleHideExport = () => {
        setShowExport(false);
    };

    return (
        <div className="tauri-filter d-flex align-items-center">
            <div className="label-date mx-1">From</div>
            <Dropdown className="mr-3">
                <Dropdown.Toggle variant="secondary" id="monthDropdown">
                    {months[selectedFromMonth - 1]}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    {months.map((month, index) => (
                        <Dropdown.Item key={index} onClick={() => handleFromMonthChange(index)}>{month}</Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>

            <Dropdown className="mr-3">
                <Dropdown.Toggle variant="secondary" id="yearDropdown">
                    {selectedFromYear}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    {years.map((year, index) => (
                        <Dropdown.Item key={index} onClick={() => handleFromYearChange(year)}>{year}</Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>

            <div className="label-date mx-1">To</div>

            <Dropdown className="mr-3">
                <Dropdown.Toggle variant="secondary" id="toMonthDropdown">
                    {months[selectedToMonth - 1]}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    {months.map((month, index) => (
                        <Dropdown.Item key={index} onClick={() => handleToMonthChange(index)}>{month}</Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>

            <Dropdown className="mr-3">
                <Dropdown.Toggle variant="secondary" id="toYearDropdown">
                    {selectedToYear}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    {years.map((year, index) => (
                        <Dropdown.Item key={index} onClick={() => handleToYearChange(year)}>{year}</Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>

            {accessDetails.length > 0 && accessDetails[0] !== '' && (
                <Dropdown className="code-filter mr-3">
                    <Dropdown.Toggle variant="secondary" id="codeDropdown">
                        {selectedCode === 'ALL' ? 'ALL' : selectedCode || 'ALL'}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item onClick={() => handleCodeChange('ALL')}>ALL</Dropdown.Item>
                        {accessDetails.map((code, index) => (
                            <Dropdown.Item key={index} onClick={() => handleCodeChange(code.trim())}>{code.trim()}</Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
            )}

            {configTypeCode.length > 1 && (
                <Dropdown className="mr-3">
                    <Dropdown.Toggle variant="secondary" id="configtypeDropdown">
                        {selectedConfigTypeCode || '--Select ConfigType--'}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {configTypeCode.map((config, index) => (
                            <Dropdown.Item key={index} onClick={() => handleConfigTypeCodeChange(config.trim())}>{config.trim()}</Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
            )}

            <img src={process.env.PUBLIC_URL + "/Images/download.svg"} alt="Download" className="d-none" onClick={handleExportClick} />
            <img src={process.env.PUBLIC_URL + "/Images/email.svg"} alt="Email" className="d-none" />
            <img src={process.env.PUBLIC_URL + "/Images/share.svg"} alt="Share" className="d-none" />

            {showExport &&
                <TauriExportDialog show={showExport} onHide={handleHideExport} />
            }
        </div>
    );
};

export default TauriFilter;
